import { render, staticRenderFns } from "./redpacketRank.vue?vue&type=template&id=27e5d46d&scoped=true&"
import script from "./redpacketRank.vue?vue&type=script&lang=js&"
export * from "./redpacketRank.vue?vue&type=script&lang=js&"
import style0 from "./redpacketRank.vue?vue&type=style&index=0&id=27e5d46d&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "27e5d46d",
  null
  
)

export default component.exports